const OPEN_TYPE = 0
const ACCEPTED = 1
const REJECTED = 2
const CLOSED = 3
export const IMPROVEMENT_IDEAS_STATUS = Object.freeze({
  OPEN_TYPE,
  ACCEPTED,
  REJECTED,
  CLOSED,
})

export const IMPROVEMENT_IDEAS_STATUS_TYPES =  Object.freeze([
  { value: OPEN_TYPE, text: 'improvement_idea.messages.open' },
  { value: ACCEPTED, text: 'improvement_idea.messages.accepted' },
  { value: REJECTED, text: 'improvement_idea.messages.reject' },
  { value: CLOSED, text: 'improvement_idea.messages.closed' },
])

export const IMPROVEMENT_IDEA_OPEN_AND_ACCEPTED_STATUS = [OPEN_TYPE, ACCEPTED] 

export const getImprovementIdeaStatusText = function (status) {
  const improvementIdeaStatus = IMPROVEMENT_IDEAS_STATUS_TYPES.find(_status => _status.value === status)
  return improvementIdeaStatus ? improvementIdeaStatus.text : null
}

export const IMPROVEMENT_IDEA_RELATIONSHIPS = {
  kpiCard: 'kpi_card',
}

export const MPS_IDEAS_LIST_URL = `${MPS_URL}/improvement-ideas/list`
